// @ts-nocheck
import React, { ChangeEvent, Component } from 'react';

import { DraperyOrderDesignLining } from './calculator';
import FabricsLiningsComponent from './fabrics-tab-linings-component';
import { SearchSelectProps } from '../../components/UI/search_select/search_select';
import { WorkroomSetting } from '../../redux/modules/workroom_setting';
import { DraperyModule } from '../../redux';
import type { FabricUrlImportSubmitPayload } from './fabric-url-import';
export interface Props {
  liningsList: DraperyOrderDesignLining[];
  disabled: boolean;
  romanShadeSettings: any;
  liningsPatternItems: any;
  workroomSetting?: WorkroomSetting;
  orderOriginState?: number;
  onSupplierSearch: SearchSelectProps['onSearch'];
  openSupplierModalClick(pathId: string, pathName: string): void;
  openImageModal(name: string, option: 'add' | 'delete'): void;
  openFabricsPatternModalClick(pathId: string, pathName: string): void;
  onFabricsLiningPatternSearch: SearchSelectProps['onSearch'];
  handleInputChangeForNumber(e: ChangeEvent<HTMLInputElement>): void;
  handleInputChangeForString(e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void;
  handleInputChangeForBoolean(e: ChangeEvent<HTMLInputElement>): void;
  handleSelectListChange(value: string | number, name?: string): void;
  handleSearchSelectChange(id: number, name: string, pathId: string, pathName: string): void;
  handleSearchSelectClear(pathId: string, pathName: string, key?: number): void;
  highlightedSection: string | null | undefined;
  openEditFabricsPatternModalClick(pathName: string, itemId?: number | null): void;
  workOrderEditMode: boolean;
  draperyOrder: DraperyModule.DraperyOrder & { clientName: string };
  isCopy: boolean;
  forBackValance?: boolean;
  orderType?: string;
  romanShadeProps?: any;
  onFabricUrlSubmit?: (payload: FabricUrlImportSubmitPayload) => Promise<void>;
}

// tslint:disable-next-line:no-empty-interface
export interface FabricState {}

class FabricsLiningsSection extends Component<Props, FabricState> {
  componentWillReceiveProps(
    //ovde.......
    nextProps: Readonly<Props>,
    nextContext: any
  ): void {
    for (let i = 0; i < 2; i++) {
      const nextLining = nextProps.liningsList[i];
      const currentLining = this.props.liningsList[i];

      if (nextLining && currentLining) {
        const nextLiningFabric = nextLining.draperyOrderLiningsFabric;
        const currentLiningFabric = currentLining.draperyOrderLiningsFabric;
  
        if (
          nextLining &&
          nextLiningFabric &&
          ![0, 1, 2].includes(nextLiningFabric.orderOrigin) &&
          nextLining.active &&
          nextProps.orderOriginState &&
          currentLining &&
          currentLiningFabric
        ) {
          currentLiningFabric.orderOrigin = nextProps.orderOriginState;
        }
      }

    }
  }
  public render() {
    const {
      liningsList,
      liningsPatternItems,
      workroomSetting,
      draperyOrder,
      isCopy,
      forBackValance,
    } = this.props;
    if (!liningsList || !liningsList.length) return null;

    // const arr = [
    //     {
    //         id: 0,
    //         name: "Lining",
    //         active: false,
    //         description: "",
    //         draperyOrderDesignId: null,
    //     },
    //     {
    //         id: 0,
    //         name: "Interlining",
    //         active: false,
    //         description: "",
    //         draperyOrderDesignId: null,
    //     },
    // ];

    const backValanceCheck =
      this.props.romanShadeProps &&
      this.props.romanShadeProps.valanceAndReturns &&
      this.props.romanShadeProps.valanceAndReturns.backValance &&
      this.props.romanShadeProps.valanceAndReturns.backValance > 0 &&
      liningsList.filter((lin: any) => lin.name === 'Lining').every((lin: any) => !lin.active)
        ? true
        : false;

    return liningsList.map((lining, index) => {
      const { name } = lining;

      // if not forBackValance, dont change anything
      if (!forBackValance) {
        if (!liningsList[index].active && !backValanceCheck) {
          // liningsList[index] = arr[index]
          return;
        }
        // @ts-ignore
        if (
          liningsList[index] &&
          liningsList[index].draperyOrderLiningsFabric &&
          liningsList[index].draperyOrderLiningsFabric.isBackValance
        ) {
          // @ts-ignore
          liningsList[index].draperyOrderLiningsFabric.isBackValance = false;
        }
      } else if (index === 1) {
        return;
      }

      return (
        <FabricsLiningsComponent
          key={`${name}-${index}`}
          disabled={this.props.disabled}
          draperyOrderDesignLining={lining}
          targetArray="liningsList"
          romanShadeSettings={this.props.romanShadeSettings}
          targetArrayIndex={index}
          type={20}
          openFabricsPatternModalClick={this.props.openFabricsPatternModalClick}
          onFabricsLiningPatternSearch={this.props.onFabricsLiningPatternSearch}
          onSupplierSearch={this.props.onSupplierSearch}
          openSupplierModalClick={this.props.openSupplierModalClick}
          openImageModal={this.props.openImageModal}
          handleInputChangeForNumber={this.props.handleInputChangeForNumber}
          handleInputChangeForString={this.props.handleInputChangeForString}
          handleInputChangeForBoolean={this.props.handleInputChangeForBoolean}
          handleSelectListChange={this.props.handleSelectListChange}
          handleSearchSelectChange={this.props.handleSearchSelectChange}
          handleSearchSelectClear={this.props.handleSearchSelectClear}
          highlightedSection={this.props.highlightedSection}
          liningsPatternItems={liningsPatternItems}
          workroomSetting={workroomSetting}
          openEditFabricsPatternModalClick={this.props.openEditFabricsPatternModalClick}
          workOrderEditMode={this.props.workOrderEditMode}
          draperyOrder={draperyOrder}
          isCopy={isCopy}
          forBackValance={backValanceCheck}
          orderType={this.props.orderType}
          onFabricUrlSubmit={this.props.onFabricUrlSubmit}
        />
      );
    });
  }
}

export default FabricsLiningsSection;
